<template>
    <div class="loader text-center">
        <i class="fa-4x fa-spin" :class="showIcon"></i>
        <p class="text-center">{{ text }}</p>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: ['text', 'icon'],
        data: function(){
            return {
                defaultIcon: "fal fa-tire"
            }
        },
        computed: {
            showIcon(){
                if(this.icon){
                    return this.icon;
                }
                return this.defaultIcon;
            }
        }
    }
</script>

<style scoped>

</style>